<template>
	<transition name="fade" mode="out-in">
		<span class="svg" v-html="html" v-if="html && !loading" @click="$emit('click', $event)"></span>
		<span class="svg" v-if="loading">
			<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="svg-loader">
				<circle cx="50" cy="50" r="45" />
			</svg>
		</span>
	</transition>
</template>

<script>
	export default {
		props: ['icon'],
		data() {
			return {
				html: '',
				loading: false
			};
		},
		watch: {
			icon: {
				handler() {
					let self = this;
					self.html = '';
					if(!self.icon) {
						return;
					}
					if(self.$store.state.icons[self.icon]) {
						self.html = self.$store.state.icons[self.icon];
						return;
					}
					if(typeof(Storage) !== 'undefined') {
						const local = localStorage.getItem(self.icon);
						if(local) {
							self.$store.state.icons[self.icon] = local;
							self.html = self.$store.state.icons[self.icon];
							return;
						} 
					}
					self.loading = true;
					self.$get('/icons/' + self.icon + '.svg').then((data) => {
						self.html = data;
						self.$store.state.icons[self.icon] = data;
						if(typeof(Storage) !== 'undefined') {
							localStorage.setItem(self.icon, data);
						}
					}).catch((error) => {}).then(() => {
						self.loading = false;
					});
				},
				immediate: true,
				deep: true
			}
		}
	}
</script>